import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-nav gfu-nav--secondary _px-0 _screen--none _screen--m" }
const _hoisted_2 = { class: "gfu-layout-wrapper" }
const _hoisted_3 = { class: "gfu-nav__content" }
const _hoisted_4 = { class: "_flex _fo-y" }
const _hoisted_5 = { class: "gfu-nav__item _pl-1 _ai-c" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "gfu-link-underline__content" }
const _hoisted_8 = { class: "gfu-nav__item _ai-c" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "gfu-link-underline__content" }
const _hoisted_11 = {
  key: 0,
  class: "gfu-nav__item gfu-nav__item--selected _ai-c"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "gfu-nav__text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              class: "gfu-link gfu-link-underline",
              href: _ctx.homeUrl
            }, [
              _createVNode(_component_base_icon, {
                name: "home",
                size: "lg",
                class: "_mr-3"
              }),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Resources.Common.BreadcrumbsHomeLink), 1 /* TEXT */),
              ($props.isBlogPost)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 0,
                    name: "chevron-right",
                    class: "_ml-3"
                  }))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              class: "gfu-link gfu-link-underline",
              href: _ctx.blogUrl
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.Resources.Common.BreadcrumbsBlogLink), 1 /* TEXT */),
              ($props.isBlogPost)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 0,
                    name: "chevron-right",
                    class: "_ml-3"
                  }))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_9)
          ]),
          ($props.isBlogPost)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("a", {
                  class: "gfu-link",
                  href: $props.blogPostUrl
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString($props.blogPostTitle), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_12)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}